const BASE_URL = "https://portfolio-server-ay3e.onrender.com";

const apiService = {
  async getData(endpoint) {
    try {
      const response = await fetch(`${BASE_URL}${endpoint}`, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) throw new Error("Network error");
      return await response.json();
    } catch (error) {
      throw error;
    }
  },

  async postData(endpoint, data) {
    try {
      const response = await fetch(`${BASE_URL}${endpoint}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
        credentials: "include",
      });
      if (!response.ok) throw new Error("Network error");
      return await response.json();
    } catch (error) {
      throw error;
    }
  },
};

export default apiService;
